var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-flex",
        { attrs: { md12: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Establecer Personalización" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", md4: "" } },
                            [
                              _c("v-switch", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "`required`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.activeCustom
                                    ? "Desactivar"
                                    : "Activar",
                                  id: "activar_custom",
                                  color: "green",
                                  hint: _vm.hint,
                                  "persistent-hint": true
                                },
                                on: { change: _vm.cleanInput },
                                model: {
                                  value: _vm.activeCustom,
                                  callback: function($$v) {
                                    _vm.activeCustom = $$v
                                  },
                                  expression: "activeCustom"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Nombre Personalizado",
                                  "single-line": "",
                                  type: "text"
                                },
                                model: {
                                  value: _vm.customName,
                                  callback: function($$v) {
                                    _vm.customName = $$v
                                  },
                                  expression: "customName"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-style": "italic",
                                    margin: "0 auto",
                                    "font-size": "12px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "El nombre ingresado sera la definición para visualizar el\n                dashboard"
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("br"),
                          _c("br"),
                          _c(
                            "v-flex",
                            {
                              attrs: { xs4: "", sm4: "", md4: "", layout: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-sucursal",
                                  staticStyle: { "margin-top": "10px" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.image.click()
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("attach_file")])],
                                1
                              ),
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "tamanio",
                                    expression: "'tamanio'"
                                  }
                                ],
                                attrs: {
                                  xs8: "",
                                  sm8: "",
                                  md8: "",
                                  label: "Seleccione Archivo",
                                  heigh: "",
                                  "error-messages": _vm.errors.collect(
                                    "archivo"
                                  ),
                                  "data-vv-name": "archivo",
                                  readonly: "readonly"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.image.click()
                                  }
                                },
                                model: {
                                  value: _vm.fileName,
                                  callback: function($$v) {
                                    _vm.fileName = $$v
                                  },
                                  expression: "fileName"
                                }
                              }),
                              _c("input", {
                                key: _vm.idkey,
                                ref: "image",
                                staticStyle: { display: "none" },
                                attrs: { type: "file", accept: "*" },
                                on: { change: _vm.onFilePicked }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs8: "", sm6: "", md6: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    id: "btnExportCsv",
                                    flat: "",
                                    small: "",
                                    color: "primary"
                                  },
                                  on: { click: _vm.onBtnDwnld }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { staticClass: "importExportBtnIcon" },
                                    [_vm._v("cloud_download ")]
                                  ),
                                  _vm._v("  \n                "),
                                  _c(
                                    "span",
                                    { staticClass: "importExportBtnTexto" },
                                    [_vm._v("Descargar")]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-style": "italic",
                                    margin: "0 auto",
                                    "font-size": "12px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Se recomienda utilizar el formato de la siguiente plantilla\n                para evitar conflictos al momento de cargar la solicitud. Por\n                favor, ingresar los datos según los formatos que se muestran\n                en la fila de ejemplo de la plantilla."
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs12: "",
                            sm12: "",
                            md12: "",
                            wrap: "",
                            layout: ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm6: "",
                                md6: "",
                                "wrapper-files": ""
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    display: "flex",
                                    "justify-content": "flex-end"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: { height: "47px" },
                                      attrs: { color: "#ffe800" },
                                      on: { click: _vm.handleClick }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Guardar\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }